/* unplugin-vue-components disabled */import { render } from "./CourseCard.vue?vue&type=template&id=f3d651a6&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=js"
export * from "./CourseCard.vue?vue&type=script&lang=js"

import "./CourseCard.vue?vue&type=style&index=0&id=f3d651a6&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户南京邮电-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d651a6"]])

export default __exports__